import type { LocumPayWeek } from './api';

const fmt = (ymd: string, opts: Intl.DateTimeFormatOptions) =>
  new Intl.DateTimeFormat('en-GB', { ...opts, timeZone: 'UTC' }).format(
    new Date(`${ymd}T00:00:00Z`),
  );

/** RL-1808 (gap #105): "12–18 Oct 2026", or "28 Sep – 4 Oct 2026" across months. */
export function weekLabel(
  row: Pick<LocumPayWeek, 'weekStartsOn' | 'weekEndsOn'>,
) {
  const [a, b] = [row.weekStartsOn, row.weekEndsOn];
  const end = fmt(b, { day: 'numeric', month: 'short', year: 'numeric' });
  if (a.slice(0, 7) === b.slice(0, 7))
    return `${fmt(a, { day: 'numeric' })}–${end}`;
  if (a.slice(0, 4) === b.slice(0, 4))
    return `${fmt(a, { day: 'numeric', month: 'short' })} – ${end}`;
  return `${fmt(a, { day: 'numeric', month: 'short', year: 'numeric' })} – ${end}`;
}

const when = (iso: string) =>
  new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    timeZone: 'Asia/Kuala_Lumpur',
  }).format(new Date(iso));

/** RL-1808: who approved and paid the week, when, and the bank reference. */
export function payHistory(row: LocumPayWeek): string[] {
  const lines: string[] = [];
  if (row.approvedAt)
    lines.push(
      `Approved ${when(row.approvedAt)}${row.approvedByName ? ` by ${row.approvedByName}` : ''}`,
    );
  if (row.paidAt)
    lines.push(
      `Paid ${when(row.paidAt)}${row.paidByName ? ` by ${row.paidByName}` : ''}${row.bankReference ? ` · ${row.bankReference}` : ''}`,
    );
  return lines;
}
